module.exports = __webpack_public_path__ + "img/gb-sct.b45a76f9.svg";